<!-- <div class="card">
  <div class="card-body">
    <h6 class="mb-0 fw-bolder fs-5">{{ tittle }}</h6>
    <p class="card-text">
      {{ description }}
    </p>
    <a href="#" class="btn btn-primary">Go somewhere</a>
  </div>
</div> -->

<div class="retry-card retry-card--primary pb-3" (click)="onToSigne()">
  <!-- Información del documento -->
  <div class="retry-card__content">
    <!-- Icono -->
    <div class="retry-card__icon">
      <i class="bi bi-file-earmark-text"></i>
    </div>

    <!-- Datos -->
    <div class="retry-card__info">
      <h5 class="retry-card__title">{{ tittle }}</h5>

      <div class="retry-card__meta">
        <!-- <span>
          <i class="bi bi-person"></i>
          Carlos Ruiz
        </span> -->

        <span>
          <i class="bi bi-calendar3"></i>
          {{ date }}
        </span>
      </div>

      <!-- Estado -->
      <div class="retry-card__status">
        <i class="bi bi-pen-fill"></i>
        Seleccione para firmar
      </div>
    </div>
  </div>

  <!-- Acciones -->
  <!-- <div class="retry-card__actions">
    <button
      type="button"
      class="retry-card__btn retry-card__btn--primary"
      (click)="onToSigne()"
    >
      <i class="bi bi-pen-fill"></i>
      Firmar
    </button>

    <button type="button" class="retry-card__btn retry-card__btn--secondary">
      Detalles
    </button>
  </div> -->
</div>
